import OneSignal from 'react-onesignal'
import axios from 'axios'
import type { AsyncAction } from 'src/state/_types'
import logger from 'src/utils/logger'

export const requestNotificationPermission: AsyncAction = async ({ state }) => {

    try {

        await OneSignal.Notifications.requestPermission()

        const permission = OneSignal.Notifications.permission
        state.notifications.permission = permission ? 'granted' : 'denied'

        if (permission) {
            // Wait briefly for subscription ID to be assigned
            await new Promise(resolve => setTimeout(resolve, 1000))

            const subscriptionId = OneSignal.User.PushSubscription.id
            state.notifications.subscriptionId = subscriptionId ?? null

            if (subscriptionId && state.auth.user_id && state.auth.tenant_id) {
                await axios.post(`${import.meta.env.VITE_AUTH_API_HOST}/notifications/subscribe`, {
                    user_id: state.auth.user_id,
                    tenant_id: state.auth.tenant_id,
                    onesignal_subscription_id: subscriptionId,
                    device_label: navigator.userAgent,
                }, { withCredentials: true })
                logger('OneSignal: Subscription registered with backend')
            }
        }

    } catch (err) {
        logger(`OneSignal: Permission request failed - ${err}`)
    }

}
